/* =====================================================================
   GN CRO/SEO v4 — productpagina
   - Sticky add-to-cart: voegt alleen het hoofdproduct 1x toe (bewust zonder
     stapelkorting/bundel/cadeau) en opent de cart drawer
   - Levermoment/betaaliconen staan nu in Liquid (gn-delivery-line, gn-payments)
   - FAQ in de beschrijving → accordeon
   - Lege "combineren met"-kop verbergen
   Alles defensief: als iets niet gevonden wordt, gebeurt er gewoon niets.
   ===================================================================== */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* --------------------------------------------------------------
     Helpers
     -------------------------------------------------------------- */
  function mainForm() {
    return document.querySelector('form[id^="main-product-form-"]');
  }
  function mainButton() {
    var form = mainForm();
    if (!form) return null;
    return (
      form.querySelector('button[name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('input[type="submit"]')
    );
  }

  /* --------------------------------------------------------------
     Sticky add-to-cart
     -------------------------------------------------------------- */
  function initSticky() {
    var bar = document.querySelector('[data-gn-sticky]');
    var btn = mainButton();
    if (!bar || !btn) return;

    var stickyBtn = bar.querySelector('[data-gn-sticky-btn]');
    var isMobile = window.matchMedia('(max-width: 760px)');

    // Zwevende knoppen rechtsonder (cookie-icoon, chat, e.d.) boven de balk houden
    var lifted = [];
    function resetFloaters() {
      lifted.forEach(function (el) { el.style.removeProperty('translate'); el.style.removeProperty('scale'); el.style.removeProperty('opacity'); });
      lifted = [];
    }
    function collectFixed(root, out) {
      var els = root.querySelectorAll('*');
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (el.shadowRoot) collectFixed(el.shadowRoot, out);
        if (el.tagName === 'SCRIPT' || el.tagName === 'STYLE' || el.tagName === 'LINK') continue;
        var cs = window.getComputedStyle(el);
        if (cs.position === 'fixed') out.push(el);
      }
      return out;
    }
    function isShown(cs) {
      return cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0';
    }
    function isClear(cs) {
      var bg = cs.backgroundColor;
      return (bg === 'transparent' || /rgba\(.*,\s*0\)$/.test(bg)) && cs.backgroundImage === 'none' && cs.boxShadow === 'none';
    }
    function liftOne(el, r, shift) {
      if (lifted.indexOf(el) > -1) return;
      el.style.setProperty('translate', '0 -' + shift + 'px', 'important');
      el.style.setProperty('transition', 'translate .25s ease, scale .25s ease, opacity .25s ease');
      if (r.width <= 72 && r.height <= 72) {
        el.style.setProperty('scale', '0.8', 'important');
        el.style.setProperty('opacity', '0.85', 'important');
      }
      lifted.push(el);
    }
    var fixedCache = null;
    function liftFloaters(useCache) {
      var barRect = bar.getBoundingClientRect();
      var shift = Math.round(barRect.height + 10);
      var vh = window.innerHeight;
      var zone = vh - barRect.height - 2;
      var fixed = (useCache && fixedCache) ? fixedCache : (fixedCache = collectFixed(document, []));
      // Kleine zichtbare knop binnen een grote, doorzichtige zwevende laag (bijv. cookie-icoon van Pandectes)
      function walk(node, depth) {
        if (depth > 6) return;
        var kids = node.children || [];
        for (var k = 0; k < kids.length; k++) {
          var c = kids[k];
          var ccs = window.getComputedStyle(c);
          if (!isShown(ccs)) continue;
          var cr = c.getBoundingClientRect();
          if (cr.width === 0 || cr.height === 0) { walk(c, depth + 1); continue; }
          if (cr.bottom < zone) continue;
          if (cr.height <= 180 && cr.width <= 260) liftOne(c, cr, shift);
          else if (isClear(ccs)) walk(c, depth + 1);
        }
        if (node.shadowRoot) walk(node.shadowRoot, depth + 1);
      }
      for (var i = 0; i < fixed.length; i++) {
        var el = fixed[i];
        if (lifted.indexOf(el) > -1) continue;
        if (el === bar || bar.contains(el) || el.contains(bar)) continue;
        if (el.closest && el.closest('#cart, .m6pn, [aria-modal="true"]')) continue;
        var cs = window.getComputedStyle(el);
        if (!isShown(cs)) continue;
        var r = el.getBoundingClientRect();
        if (r.width === 0 || r.height === 0) continue;
        if (r.bottom < zone) continue;                          // zit al boven de balk
        if (r.height > 180 || r.width > 260) {                  // grote laag: alleen als die zelf doorzichtig is
          if (isClear(cs)) walk(el, 0);
          continue;
        }
        liftOne(el, r, shift);
      }
    }
    // Widgets die later laden (cookie-icoon) ook oppakken
    // (maximaal 8 keer scannen, daarna is de pagina uitgeladen — spaart CPU op mobiel)
    var liftRuns = 0;
    var liftTimer = setInterval(function () {
      if (!bar.classList.contains('is-visible')) return;
      if (++liftRuns > 8) { clearInterval(liftTimer); return; }
      try { liftFloaters(); } catch (e) {}
    }, 1500);
    var scrollScans = 0, scrollBusy = false;
    window.addEventListener('scroll', function () {
      if (scrollBusy || scrollScans > 40 || !bar.classList.contains('is-visible')) return;
      scrollBusy = true;
      setTimeout(function () { scrollBusy = false; if (!bar.classList.contains('is-visible')) return; scrollScans++; try { liftFloaters(true); } catch (e) {} }, 700);
    }, { passive: true });

    // Is er een paneel open (cart drawer, quickshop, menu)? Dan geen sticky-balk.
    function panelOpen() {
      var panels = document.querySelectorAll('#cart, .m6pn, #quickshop, [aria-modal="true"]');
      for (var i = 0; i < panels.length; i++) {
        var p = panels[i];
        if (p.getAttribute('aria-hidden') === 'false') return true;
        var cs = window.getComputedStyle(p);
        if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) continue;
        var r = p.getBoundingClientRect();
        if (r.width > 40 && r.height > 40 && r.left < window.innerWidth - 20 && r.right > 20 &&
            r.top < window.innerHeight && r.bottom > 0) return true;
      }
      var cls = document.documentElement.className + ' ' + document.body.className;
      return /cart-open|m6pn-open|panel-open|overlay-open|side-cart-open|quickshop-open|menu-open/.test(cls);
    }

    var wanted = false;
    function apply() {
      var on = wanted && !panelOpen();
      if (on === bar.classList.contains('is-visible')) return;
      try { if (on) liftFloaters(); else resetFloaters(); } catch (e) {}
      bar.classList.toggle('is-visible', on);
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      document.body.classList.toggle('gn-sticky-active', on);
    }
    function show(on) {
      wanted = on;
      apply();
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        // Toon de balk als de echte knop uit beeld is én we er voorbij zijn (of ver genoeg gescrold)
        var passed = e.boundingClientRect.top < 0 || window.scrollY > 500;
        show(!e.isIntersecting && passed);
      }, { threshold: 0 });
      io.observe(btn);
    } else {
      window.addEventListener('scroll', function () {
        var r = btn.getBoundingClientRect();
        show(r.bottom < 0);
      }, { passive: true });
    }

    // Opnieuw beoordelen zodra een paneel opent/sluit (klassen, aria, inline style) of na klikken
    var pending = null;
    function recheck() {
      clearTimeout(pending);
      pending = setTimeout(apply, 30);
      setTimeout(apply, 400);   // na de open/dicht-animatie nog een keer
    }
    var mo = new MutationObserver(recheck);
    mo.observe(document.body, { attributes: true, attributeFilter: ['class', 'style'] });
    mo.observe(document.documentElement, { attributes: true, attributeFilter: ['class', 'style'] });
    var cartEl = document.getElementById('cart');
    if (cartEl) mo.observe(cartEl, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden'] });
    document.addEventListener('click', recheck, true);
    window.addEventListener('resize', recheck);

    // Sticky-knop: ALLEEN het hoofdproduct, 1 stuk (geen stapel/bundel/cadeau).
    function currentVariantId() {
      var form = mainForm();
      var input = form && form.querySelector('input[name="id"], select[name="id"]');
      var v = input && input.value ? parseInt(input.value, 10) : 0;
      return v || parseInt(bar.dataset.variantId, 10) || 0;
    }
    function openDrawer() {
      // Xtra opent de side cart via de winkelwagen-link in de header
      var link = document.querySelector('header a[href$="/cart"], #header a[href$="/cart"], a[href$="/cart"]');
      if (link) { link.click(); return true; }
      return false;
    }
    stickyBtn.addEventListener('click', function () {
      var id = currentVariantId();
      if (!id) return;
      stickyBtn.disabled = true;
      fetch((bar.dataset.addUrl || '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      }).then(function () {
        document.dispatchEvent(new CustomEvent('gn:cart:added', { detail: { id: id } }));
        if (!openDrawer()) window.location.href = bar.dataset.cartUrl || '/cart';
      }).catch(function () {
        window.location.href = bar.dataset.cartUrl || '/cart';
      }).finally(function () {
        setTimeout(function () { stickyBtn.disabled = false; }, 800);
      });
    });

    // Prijs in de balk meebewegen met de prijs in de buy-box (variantwissel)
    var boxPrice = document.querySelector('.m6pr .price, .m6pr [class*="price"]');
    var barPrice = bar.querySelector('[data-gn-sticky-price]');
    if (boxPrice && barPrice) {
      var sync = function () {
        var t = boxPrice.textContent.replace(/\s+/g, ' ').trim();
        var m = t.match(/€\s?\d[\d.,]*/g);
        if (m && m.length) barPrice.textContent = m[m.length - 1];
      };
      new MutationObserver(sync).observe(boxPrice, { childList: true, subtree: true, characterData: true });
    }
  }

  /* --------------------------------------------------------------
     FAQ in de beschrijving → accordeon
     -------------------------------------------------------------- */
  function initFaq() {
    var info = document.getElementById('section-info');
    if (!info) return;
    var heads = info.querySelectorAll('h3');
    var faqHead = null;
    for (var i = 0; i < heads.length; i++) {
      if (/veelgestelde vragen/i.test(heads[i].textContent)) { faqHead = heads[i]; break; }
    }
    if (!faqHead) return;

    var wrap = document.createElement('div');
    wrap.className = 'gn-faq';
    var node = faqHead.nextElementSibling;
    var current = null;
    while (node) {
      var next = node.nextElementSibling;
      if (node.tagName === 'H4') {
        current = document.createElement('details');
        var sum = document.createElement('summary');
        sum.textContent = node.textContent.trim();
        current.appendChild(sum);
        wrap.appendChild(current);
        node.remove();
      } else if (current && !/^H[1-3]$/.test(node.tagName)) {
        current.appendChild(node);
      } else {
        break;
      }
      node = next;
    }
    if (wrap.children.length) {
      faqHead.parentNode.insertBefore(wrap, faqHead.nextSibling);
      var first = wrap.querySelector('details');
      if (first) first.open = true;
    }
  }

  /* --------------------------------------------------------------
     Lege "combineren met"-kop verbergen
     -------------------------------------------------------------- */
  function hideEmptyComplementary() {
    var all = document.querySelectorAll('.m6pr h2, .m6pr h3, .m6pr h4, .m6pr h5, .m6pr strong, .m6pr p');
    for (var i = 0; i < all.length; i++) {
      var el = all[i];
      if (!/combineren met onderstaande producten/i.test(el.textContent)) continue;
      var box = el.closest('[class*="block"], section, div');
      var hasProducts = box && box.querySelector('a[href*="/products/"]');
      if (!hasProducts) {
        (box && box !== el && box.children.length <= 2 ? box : el).style.display = 'none';
      }
      break;
    }
  }

  /* --------------------------------------------------------------
     "Vaak samen gekocht": 1x toevoegen via /cart/add.js en drawer openen
     -------------------------------------------------------------- */
  function initFbt() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest && e.target.closest('[data-gn-fbt-add]');
      if (!btn) return;
      e.preventDefault();
      var id = parseInt(btn.getAttribute('data-gn-fbt-add'), 10);
      if (!id || btn.disabled) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        var span = btn.querySelector('span');
        if (span) span.textContent = 'Toegevoegd';
        var link = document.querySelector('header a[href$="/cart"], #header a[href$="/cart"], a[href$="/cart"]');
        if (link) link.click(); else window.location.href = '/cart';
      }).catch(function () {
        window.location.href = '/cart';
      }).finally(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-loading', 'is-added');
          var span = btn.querySelector('span');
          if (span) span.textContent = 'Voeg toe';
        }, 2500);
      });
    });
  }

  /* --------------------------------------------------------------
     Productbeschrijving: alleen opmaak (tekst blijft ongewijzigd)
     - "Wat zit er in de doos" → vinkjes-lijst
     - "Specificaties" → label | waarde rijen
     - "Ook verkrijgbaar" → pill-links
     - FAQ-items → accordeon
     -------------------------------------------------------------- */
  function initDescription() {
    var root = document.querySelector('#section-info section[class^="gn-"][class$="-seo"]');
    if (!root) return;
    var boxes = root.querySelectorAll('[class$="-soft"], [class$="-card"]');
    for (var i = 0; i < boxes.length; i++) {
      var b = boxes[i];
      var h = b.querySelector('h3');
      var t = h ? h.textContent.toLowerCase() : '';
      if (/in de doos/.test(t)) b.classList.add('gn-d-box');
      else if (/specificatie/.test(t)) {
        b.classList.add('gn-d-specs');
        var lis = b.querySelectorAll('li');
        for (var k = 0; k < lis.length; k++) {
          var li = lis[k];
          if (li.querySelector('.gn-spec-k')) continue;
          var html = li.innerHTML;
          var idx = html.indexOf(':');
          if (idx < 1) continue;
          li.innerHTML = '<span class="gn-spec-k">' + html.slice(0, idx) + '</span><span class="gn-spec-v">' + html.slice(idx + 1).replace(/^\s+/, '') + '</span>';
        }
      } else if (/verkrijgbaar|uitvoering/.test(t)) b.classList.add('gn-d-variants');
    }
    var items = root.querySelectorAll('[class$="-faq-item"]');
    for (var j = 0; j < items.length; j++) {
      var it = items[j];
      if (it.querySelector('details')) continue;
      var q = it.querySelector('h4');
      if (!q) continue;
      var det = document.createElement('details');
      var sum = document.createElement('summary');
      sum.textContent = q.textContent.trim();
      det.appendChild(sum);
      while (q.nextSibling) det.appendChild(q.nextSibling);
      q.remove();
      it.appendChild(det);
    }
  }

  ready(function () {
    try { initDescription(); } catch (e) {}
    try { initFbt(); } catch (e) {}
    try { initSticky(); } catch (e) {}
    try { initFaq(); } catch (e) {}
    try { hideEmptyComplementary(); } catch (e) {}
  });
})();

